<template>
    <div>{{msg}}</div>
</template>

<script>
export default {
    name: 'authorizerResult',
    data() {
        return {
            msg: ''
        };
    },
    created() {
        // this.getData();
        this.uuid = this.$route.query.uuid;
        this.authCode = this.$route.query.auth_code;
        if(!this.uuid || !this.authCode){
            this.msg = '参数错误，请重试';
            return false;
        }
        this.postRequest('/wenjiaoopne/open/authCallback',this.$route.query).then((result) => {
            if(result.error_code > 0){
                this.msg = '请求错误，请重试';
                return false;
            }
            this.msg = '绑定成功';
            // this.$router.push('/login');
        })
        
    },
    methods: {

    }
};
</script>

<style scoped>

</style>